module.exports = __webpack_public_path__ + "media/images/workplace/intro-page/step1-3-p-33eac56d05b7e7c4f4aba6c34c9c13c9.gif";